import { types } from 'mobx-state-tree'

import { DataStoreModel } from './data-store/data-store'
export const RootStoreModel = types.model({
  data: DataStoreModel,
})
export type RootStore = typeof RootStoreModel.Type
export type RootStoreSnapshot = typeof RootStoreModel.SnapshotType
